var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "workpermit-content-slot" },
    [
      _c("GeneralInfo", {
        ref: "generalInfo",
        attrs: {
          isEdit: false,
          isProjectAvailable: _vm.isProjectAvailable,
          isStandalone: _vm.isStandalone,
        },
      }),
      _vm._v(" "),
      _vm.showSaTncLink
        ? _c(
            "a",
            {
              on: {
                click: function () {
                  return _vm.openSaWpTncModal()
                },
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("view")) +
                  " " +
                  _vm._s(_vm.$t("tncName")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "workpermit-content-slot__view-workerinfo",
          on: {
            click: function () {
              return _vm.viewWorkerInfo()
            },
          },
        },
        [
          _c("img", {
            attrs: { alt: "worker info", src: "/ic_worker_info.png" },
          }),
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("view")) +
              " " +
              _vm._s(_vm.$t("workPermit.workerInfo")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showContractorHistoryCommentsSection
        ? [
            _vm._l(_vm.historyBlocksForViewer, function (item) {
              return _c(
                "div",
                {
                  key: item.status,
                  staticClass: "workpermit-content-slot__review-box",
                  class: {
                    "workpermit-content-slot__review-box--history-split":
                      _vm.historyRowUsesEngineerReviewerSplit(item),
                    "workpermit-content-slot__review-box--tenant-external-only":
                      item.externalContent && !_vm.isEngineer,
                  },
                },
                [
                  _vm.historyRowUsesEngineerApproverSingle(item)
                    ? [
                        _c("WpHistoryCommentHeading", {
                          attrs: {
                            index: item.index,
                            title: item.title,
                            byline: item.by,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "pre",
                          {
                            staticClass: "workpermit-content-slot__history-pre",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.historyCommentDisplay(
                                  _vm.approverHistoryBodyText(item)
                                ) || _vm.emptyValue
                              )
                            ),
                          ]
                        ),
                      ]
                    : _vm.historyRowUsesEngineerReviewerSplit(item)
                    ? [
                        _vm.historyRowUsesDisclosureGrid(item)
                          ? _c("WpHistoryDisclosureGrid", {
                              attrs: {
                                item: item,
                                "internal-body": _vm.historyCommentDisplay(
                                  item.content
                                ),
                                "external-body": _vm.historyCommentDisplay(
                                  item.externalContent
                                ),
                                "disclosure-checked":
                                  _vm.historyRowDisclosureChecked(item),
                                "disclosure-disabled":
                                  !_vm.historyRowShowsExternalApproverChrome(
                                    item.status
                                  ),
                              },
                              on: {
                                "disclosure-change": function ($event) {
                                  return _vm.setHistoryExternalDisclosed(
                                    item.status,
                                    $event
                                  )
                                },
                              },
                            })
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "workpermit-content-slot__history-split-body",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "workpermit-content-slot__history-split-heading-row",
                                  },
                                  [
                                    _c("WpHistoryCommentHeading", {
                                      attrs: {
                                        index: item.index,
                                        title: item.title,
                                        byline: item.by,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "workpermit-content-slot__history-split-left",
                                  },
                                  [
                                    _c("WpHistoryInternalCommentBlock", {
                                      attrs: {
                                        text: _vm.historyCommentDisplay(
                                          item.content
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("WpHistoryExternalCommentsColumn", {
                                  attrs: {
                                    "external-display-text":
                                      _vm.historyCommentDisplay(
                                        item.externalContent
                                      ),
                                  },
                                }),
                              ],
                              1
                            ),
                      ]
                    : _vm.historyRowUsesTenantExternalOnly(item)
                    ? [
                        _c("WpHistoryCommentHeading", {
                          attrs: {
                            index: item.index,
                            title: item.title,
                            byline: item.by,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "pre",
                          {
                            staticClass: "workpermit-content-slot__history-pre",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.historyCommentDisplay(item.externalContent)
                              )
                            ),
                          ]
                        ),
                      ]
                    : _vm.historyRowUsesTenantApproverSingle(item)
                    ? [
                        _c("WpHistoryCommentHeading", {
                          attrs: {
                            index: item.index,
                            title: item.title,
                            byline: item.by,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "pre",
                          {
                            staticClass: "workpermit-content-slot__history-pre",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.historyCommentDisplay(
                                  _vm.approverHistoryBodyText(item)
                                ) || _vm.emptyValue
                              )
                            ),
                          ]
                        ),
                      ]
                    : _vm.historyRowUsesEngineerInternalOrEmpty(item)
                    ? [
                        _c("WpHistoryCommentHeading", {
                          attrs: {
                            index: item.index,
                            title: item.title,
                            byline: item.by,
                          },
                        }),
                        _vm._v(" "),
                        !_vm.historyTextMeaningful(item.content) &&
                        !_vm.historyTextMeaningful(item.externalContent)
                          ? [
                              _c(
                                "pre",
                                {
                                  staticClass:
                                    "workpermit-content-slot__history-pre",
                                },
                                [_vm._v(_vm._s(_vm.emptyValue))]
                              ),
                            ]
                          : _c("WpHistoryInternalCommentBlock", {
                              attrs: {
                                text: _vm.historyCommentDisplay(item.content),
                              },
                            }),
                      ]
                    : _vm._e(),
                ],
                2
              )
            }),
            _vm._v(" "),
            _vm.showTenantExternalCommentsSection
              ? _vm._l(_vm.tenantExternalCommentRows, function (item, idx) {
                  return _c(
                    "div",
                    {
                      key: "tenant-external-dedup-" + idx,
                      class: [
                        "workpermit-content-slot__review-box",
                        {
                          "workpermit-content-slot__review-box--tenant-external-only":
                            !_vm.isEngineer,
                        },
                      ],
                    },
                    [
                      _c("WpHistoryCommentHeading", {
                        attrs: {
                          index: _vm.historyBlocksForViewer.length + idx + 1,
                          title: item.title,
                          byline: item.by,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "pre",
                        { staticClass: "workpermit-content-slot__history-pre" },
                        [_vm._v(_vm._s(_vm.historyCommentDisplay(item.text)))]
                      ),
                    ],
                    1
                  )
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "approveProcess" },
        [
          _vm.isPP
            ? [
                _vm.canApprovePPInStep && _vm.isProjectAvailable
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "workpermit-content-slot__btns float-right",
                        },
                        [
                          _c("HKLButton", {
                            attrs: {
                              color: "darkblue",
                              action: "rejectAction",
                            },
                            on: {
                              click: function () {
                                return _vm.openRejectPPModal()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("HKLButton", {
                            attrs: { color: "orange", action: "approveAction" },
                            on: { click: _vm.openApproveProjectPermitModal },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm.canSecondReviewPPInStep
                  ? [
                      _c(
                        "div",
                        { staticClass: "workpermit-content-slot__review-box" },
                        [
                          _c("WpReviewerCommentFields", {
                            attrs: {
                              "internal-section-title": _vm.$t(
                                "workPermit.reviewerInternalSection2nd"
                              ),
                              "external-section-title": _vm.$t(
                                "workPermit.reviewerExternalSection2nd"
                              ),
                              "internal-value": _vm.actionComment,
                              "external-value": _vm.externalComment,
                              "leave-external-value": _vm.leaveExternalComments,
                              "external-error": _vm.rejectExternalFieldError,
                              readonly: !_vm.isProjectAvailable,
                            },
                            on: {
                              "update:internalValue": _vm.onActionCommentUpdate,
                              "update:externalValue":
                                _vm.onExternalCommentUpdate,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "workpermit-content-slot__btns" },
                            [
                              _c("HKLButton", {
                                attrs: {
                                  color: "darkblue",
                                  action: "rejectAction",
                                },
                                on: {
                                  click: function () {
                                    return _vm.openRejectProcessModal(
                                      _vm.WORK_PERMIT_STATUS.REVIEWED
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("HKLButton", {
                                attrs: {
                                  color: "orange",
                                  action: "nextReviewer",
                                },
                                on: {
                                  click: function () {
                                    return _vm.openNextReviewerModal(
                                      _vm.WP_ACTION_TYPE.PPApprove
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("WorkPermNextReviewerModal", {
                            ref:
                              _vm.WP_ACTION_TYPE.PPApprove +
                              "_nextReviewerModal_" +
                              _vm.permitData.id,
                            on: {
                              "multi-select-submited": _vm.confirmPPApprover,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm.canReviewPP && _vm.isWAPPR
                  ? [
                      _c(
                        "div",
                        { staticClass: "workpermit-content-slot__review-box" },
                        [
                          _c("WpReviewerCommentFields", {
                            attrs: {
                              "internal-section-title": _vm.$t(
                                "workPermit.reviewerInternalSection1st"
                              ),
                              "external-section-title": _vm.$t(
                                "workPermit.reviewerExternalSection1st"
                              ),
                              "internal-value": _vm.actionComment,
                              "external-value": _vm.externalComment,
                              "leave-external-value": _vm.leaveExternalComments,
                              "external-error": _vm.rejectExternalFieldError,
                              readonly: !_vm.isProjectAvailable,
                            },
                            on: {
                              "update:internalValue": _vm.onActionCommentUpdate,
                              "update:externalValue":
                                _vm.onExternalCommentUpdate,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isProjectAvailable,
                                  expression: "isProjectAvailable",
                                },
                              ],
                              staticClass: "workpermit-content-slot__btns",
                            },
                            [
                              _c("HKLButton", {
                                attrs: {
                                  color: "darkblue",
                                  action: "rejectAction",
                                },
                                on: {
                                  click: function () {
                                    return _vm.openRejectProcessModal(
                                      _vm.WORK_PERMIT_STATUS.ACKNOWLEDGED
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("HKLButton", {
                                attrs: {
                                  color: "orange",
                                  action: "acknowledge",
                                },
                                on: {
                                  click: function () {
                                    return _vm.openNextReviewerModal(
                                      _vm.WP_ACTION_TYPE.PPReview2
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("WorkPermNextReviewerModal", {
                        ref:
                          _vm.WP_ACTION_TYPE.PPReview2 +
                          "_nextReviewerModal_" +
                          _vm.permitData.id,
                        on: {
                          "multi-select-submited": _vm.confirmPPSecondReviewer,
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.canActionInWP
            ? [
                _c(
                  "div",
                  { staticClass: "workpermit-content-slot__review-box" },
                  [
                    _c("WpReviewerCommentFields", {
                      attrs: {
                        "internal-section-title": _vm.actionHintRef,
                        "external-section-title": _vm.actionExternalTitleRef,
                        "internal-value": _vm.reviewerPrimaryCommentValue,
                        "external-value": _vm.externalComment,
                        "leave-external-value": _vm.leaveExternalComments,
                        "allow-leave-external-comments":
                          _vm.allowLeaveExternalInReviewerForm,
                        "sole-field-is-external":
                          !_vm.allowLeaveExternalInReviewerForm,
                        "external-error": _vm.rejectExternalFieldError,
                        readonly: !_vm.isProjectAvailable,
                      },
                      on: {
                        "update:internalValue":
                          _vm.onReviewerPrimaryCommentUpdate,
                        "update:externalValue": _vm.onExternalCommentUpdate,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isProjectAvailable,
                            expression: "isProjectAvailable",
                          },
                        ],
                        staticClass: "workpermit-content-slot__btns",
                      },
                      [
                        _c(
                          "HKLButton",
                          {
                            attrs: { color: "darkblue" },
                            on: {
                              click: function () {
                                return _vm.openRejectProcessModal(
                                  _vm.nextStatusRef
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("action.rejectAction")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.actionButtonRef
                          ? _c(
                              "HKLButton",
                              _vm._g(
                                { attrs: { color: "orange" } },
                                _vm.actionButtonRef.on
                              ),
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.actionButtonRef.label) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.nextReviewerSubmitRef
                      ? _c("WorkPermNextReviewerModal", {
                          ref: "nextReviewerModal",
                          on: {
                            "multi-select-submited": _vm.nextReviewerSubmitRef,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("Modal", { ref: "approveWorkPermitModal" }, [
        _c(
          "div",
          {
            staticClass: "modal-pure-text",
            attrs: { slot: "content" },
            slot: "content",
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("workPermit.areYouApprove")) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              on: {
                click: function () {
                  return _vm.$refs.approveWorkPermitModal.close()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm.$t("action.cancel"))) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              on: {
                click: function () {
                  return _vm.approveWP()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm.$t("action.yes"))) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "approveProjectPermitModal" }, [
        _c(
          "div",
          {
            staticClass: "modal-pure-text",
            attrs: { slot: "content" },
            slot: "content",
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("workPermit.areYouApprove")) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              on: {
                click: function () {
                  return _vm.$refs.approveProjectPermitModal.close()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm.$t("action.cancel"))) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              on: {
                click: function () {
                  return _vm.approvePP()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm.$t("action.yes"))) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("Modal", { ref: "rejectProcessModal" }, [
        _c(
          "div",
          { staticClass: "modal-pure-text", attrs: { solt: "content" } },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("workPermit.areYouReject")) + "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              on: {
                click: function () {
                  return _vm.$refs.rejectProcessModal.close()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm.$t("action.cancel"))) +
                  "\n      "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              on: {
                click: function () {
                  return _vm.rejectOnProcess()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("capitalize")(_vm.$t("action.yes"))) +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "rejectPPModal",
          attrs: { afterCloseModal: _vm.onRejectPPModalAfterClose },
        },
        [
          _c(
            "div",
            { staticClass: "modal-pure-text", attrs: { solt: "modal-header" } },
            [
              _c("span", { staticClass: "required-flag" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("tender.tmview.rejectPlaceholder")) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("WpReviewerCommentFields", {
                attrs: {
                  "internal-section-title": _vm.$t(
                    "workPermit.reviewerInternalSection2nd"
                  ),
                  "external-section-title": _vm.$t(
                    "workPermit.reviewerExternalSection2nd"
                  ),
                  "internal-value": _vm.externalComment,
                  "external-value": _vm.externalComment,
                  "leave-external-value": _vm.leaveExternalComments,
                  "allow-leave-external-comments": false,
                  "sole-field-is-external": true,
                  "omit-sole-field-chrome": true,
                  "external-error": _vm.rejectExternalFieldError,
                  readonly: false,
                },
                on: {
                  "update:internalValue": _vm.onExternalCommentUpdate,
                  "update:externalValue": function (val) {
                    return (_vm.externalComment = val)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                on: {
                  click: function () {
                    return _vm.$refs.rejectPPModal.close()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("capitalize")(_vm.$t("action.cancel"))) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                on: {
                  click: function () {
                    return _vm.rejectPP()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("capitalize")(_vm.$t("action.yes"))) +
                    "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "viewWorkerInfo",
          attrs: {
            modalType: "large-modal",
            showCloseBtn: !_vm.editingWorkerInfo,
          },
        },
        [
          _c("WorkerInfo", {
            attrs: {
              slot: "content",
              showOperate:
                _vm.canUpdateWorkerInfo &&
                _vm.isProjectAvailable &&
                _vm.isPermitAvailable,
            },
            on: {
              "editing:workerInfo": function (val) {
                return (_vm.editingWorkerInfo = val)
              },
            },
            slot: "content",
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "SWPConflictModal",
        attrs: {
          modalId: "swp-conflict-" + +new Date(),
          confirmTitle: _vm.$t("standaloneWorkPermit.conflictWithWP"),
        },
      }),
      _vm._v(" "),
      _c("SAWorkPermitTnC", {
        ref: "saWpTnCModal",
        attrs: { companyName: _vm.companyName },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }